import React from 'react';
import { TableCell } from '../../../UIKit';
import { CellProps } from './CellProps';

export interface DefaultCellProps extends CellProps {
  value: any;
  formatter?: <T>(value: any) => T;
  style?: React.CSSProperties;
}

const Cell = ({ value, formatter, style, className }: DefaultCellProps) => (
  <>
    {formatter ? (
      <TableCell style={style} className={className}>
        {formatter(value)}
      </TableCell>
    ) : (
      <TableCell className={className}>{value}</TableCell>
    )}
  </>
);

export default Cell;
